const routes = [
  {
    path: '/recommendApp',
    name: '',
    redirect:'/recommendApp/list'
  },
  {
    path: '/recommendApp/list',
    name: '',
    meta:{module:'operate_manage',menu:'/recommendApp/list',title:'推荐位管理'},//menu 用于所属右侧菜单栏
    component: () => import('@/views/recommendApp/list.vue')
  },
]

export default routes;
